import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, ViewContainerRef } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';
import { OrganisationDataModelNode } from '@services/organisation-data.service';
import { DataPoint } from '@services/datapoints-data.service';
import { AccumulationChartComponent, AccumulationTooltip } from '@syncfusion/ej2-angular-charts';
import { Subject, Subscription, interval, takeUntil } from 'rxjs';

@Component({
	selector: 'app-dashboard-pie-chart',
	templateUrl: './dashboard-pie-chart.component.html',
	styleUrl: './dashboard-pie-chart.component.scss'
})
export class DashboardPieChartComponent {

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** publicPanelData */
	@Input() publicPanelData: PanelData[];

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** accountGUID */
	@Input() accountGUID: string;

	/** organisationUID */
	@Input() organisationUID: string;

	/** panelData */
	@Input() panelData: any;

	/** intervalFinish */
	@Output() intervalFinish = new EventEmitter<any>();

	/** Page Refresh Interval object */
	private refreshInterval: Subscription | null;

	/** refreshTime */
	private refreshTime: number = 0.5;

	/** pieChartLabels */
	public pieChartLabels: Object = {
		visible: true,
		position: 'Outside', name: 'name',
		// font: {
		//     size: Browser.isDevice ? '8px' : '12px',
		//     fontWeight: '600'
		// },
		// connectorStyle: { length: '40px', type: 'Curve' },
		// maxWidth: 100
	};

	/** pieChartLegendSettings */
	public pieChartLegendSettings: Object = {
		visible: true,
		// maximumLabelWidth: 500
		// width: "400",
		// position: "Bottom"
	};

	/** tooltip */
	public tooltip: Object = {
		enable: true,
		enableHighlight: true,
		format: '<b>${point.x}</b>',
		header: ''
	};

	/** examplePieChartData */
	public examplePieChartData: { title: string, nodeUID: string, name: string, usage: number }[] = [
		{ title: "Location 1", nodeUID: "ABC", name: "Area A: 5", usage: 5 },
		{ title: "Location 2", nodeUID: "DEF", name: "Area B: 3", usage: 3 },
		{ title: "Location 3", nodeUID: "GHI", name: "Area C: 1", usage: 1 },
		{ title: "Location 4", nodeUID: "KLM", name: "Area D: 7", usage: 7 }
	];

	/** nodePieChartData */
	public nodePieChartData: { title: string, nodeUID: string, name: string, usage: number }[] = [];

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions  
	 * @param eventsDataService eventsDataService 
	 * @param siteSubscriptions siteSubscriptions 
	 * @param document document 
	 * @param vcr vcr 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		public router: Router,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef
	) {
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		this.refreshInterval = interval((this.refreshTime * 60000)).pipe(takeUntil(this.finalise)).subscribe(() => {
			this.intervalFinish.emit(this.panelData);
		});

		if (this.panelData && this.creating) {
			if (this.panelData.nodeData.SubChild && this.panelData.nodeData.SubChild.length > 0) {
				this.panelData.nodeData.SubChild.forEach((x: OrganisationDataModelNode, i: number) => {
					const value: number = (i + 1) * 2;
					this.nodePieChartData.push({
						title: x.Name,
						nodeUID: x.DataModelNodeUID,
						name: `${x.Name}: ${value}`,
						usage: value
					});
				});
			} else {
				this.panelData.nodeData.Datapoints.forEach((x: DataPoint, i: number) => {
					const value: number = (i + 1) * 2;
					this.nodePieChartData.push({
						title: x.DPTitle,
						nodeUID: `${x.DataPointID}`,
						name: `${x.DPTitle}: ${value}`,
						usage: value
					});
				});
			}
		}
	}
}


AccumulationChartComponent.Inject(AccumulationTooltip);